import { Image } from '@nextui-org/react';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import Logo from '../../assets/logosomerlog.png';
import Login from '../../pages/Login/Login';

type Step = 'login' | 'newPassword';

const LoginLayout = (): JSX.Element => {
  const [layout, setLayout] = useState<Step>('login');
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const checkIfMobile = (): void => {
      setIsMobile(window.matchMedia('(max-width: 1024px)').matches);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  return (
    <div
      className={`flex ${
        isMobile ? 'h-full flex-col' : 'flex-row'
      } items-center justify-center overflow-hidden bg-background`}
    >
      {/* Title Card */}
      <div
        className={`flex ${
          isMobile ? 'h-2/5 flex-col-reverse' : 'h-screen grow flex-col'
        }  w-full min-w-[60%]   items-center justify-center`}
      >
        {/* Title */}
        <h1
          className={` text-center font-sans ${
            isMobile ? 'my-5 text-xl ' : ' my-10 text-4xl'
          }  font-bold text-foreground-600`}
        >
          Sistema Etiquetador
        </h1>

        <div className="flex w-full items-center justify-center bg-foreground-300 py-12 shadow-md dark:bg-foreground-100">
          <Image
            width={isMobile ? 300 : 450}
            className="rounded-none"
            alt="Company Logo"
            src={Logo}
          />
        </div>
      </div>

      {/* Login card */}
      <div
        style={{
          borderRadius: isMobile
            ? '0.75rem 0.75rem 0 0'
            : '0.75rem 0 0 0.75rem ',
        }}
        className={`flex ${
          isMobile ? 'h-3/5' : 'relative h-screen '
        } w-full flex-col items-center justify-center  rounded-l-xl bg-foreground-50 shadow-large`}
      >
        {/* Login */}
        <AnimatePresence>
          {layout === 'login' && (
            <motion.div
              className="absolute w-[60%]"
              key="1"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 50 }}
            >
              <Login changeLayout={() => setLayout('newPassword')} />
            </motion.div>
          )}
        </AnimatePresence>

        {/* New Password */}
        <AnimatePresence>
          {layout === 'newPassword' && (
            <motion.div
              className="absolute w-[60%]"
              key="2"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 50 }}
            >
              {/* <NewPassword chengeLayout={() => setLayout('login')} /> */}
              <p>Create new password page</p>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default LoginLayout;
